export const STORAGE_KEYS = {
  UI_THEME: 'UI_THEME',
  LAST_VERSION_CHECK_TIMESTAMP: 'lastVersionCheckTimestamp',
  VERSION_UPDATE_ATTEMPTED: 'versionUpdateAttempted',
};

export const LOCAL_FEATURE_FLAGS = {
  enableThemeAutoDetection: false,
};

export const healthCheckUrl = (serverUrl: string) => new URL('/api?query=%7B__typename%7D', serverUrl).toString();
